// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hotkey[data-v-0f3b1c45]{font-size:60%;background-color:hsla(0,0%,60%,.6);padding:0 3px;border-radius:2px;color:#fff}", ""]);
// Exports
module.exports = exports;
